import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  FieldsInterventionsGeneralIIReportComponent,
  SubReportComponent,
  SubReportElementComponent
} from './fields-interventions-general-ii-report.component';
import {
  DxAccordionModule, DxChartModule, DxCircularGaugeModule,
  DxDataGridModule,
  DxLoadPanelModule,
  DxPieChartModule, DxPivotGridModule,
  DxPopupModule,
  DxScrollViewModule
} from 'devextreme-angular';
import {
  MaterialParkDataChart1Component, MaterialParkDataChart2Component,
  MaterialParkDataComponent,
  MaterialParkDataTable1Component,
  MaterialParkDataTable2Component, MaterialParkDataTable3Component
} from './material-park-data/material-park-data.component';
import {
  MaterialUsageChart1Component, MaterialUsageChart2Component,
  MaterialUsageComponent,
  MaterialUsageTable1Component
} from './material-usage/material-usage.component';
import {MaterialUsageCampaignComponent} from './material-usage-campaign/material-usage-campaign.component';
import {ProgressionSpeedComponent, ProgressionSpeedTable1Component} from './progression-speed/progression-speed.component';
import {ThroughputComponent} from './throughput/throughput.component';
import {UsageOptimizationComponent} from './usage-optimization/usage-optimization.component';
import {OperationsSynthesisComponent} from './operations-synthesis/operations-synthesis.component';
import {OperationsProgressChart1Component, OperationsProgressComponent} from './operations-progress/operations-progress.component';
import {FuelConsumptionComponent, FuelConsumptionTable1Component} from './fuel-consumption/fuel-consumption.component';
import {DomainsSelectorModule} from 'shared';


@NgModule({
  declarations: [FieldsInterventionsGeneralIIReportComponent,
    SubReportElementComponent,
    MaterialParkDataComponent,
    MaterialParkDataTable1Component,
    MaterialParkDataTable2Component,
    MaterialParkDataTable3Component,
    MaterialParkDataChart1Component,
    MaterialParkDataChart2Component,
    MaterialUsageComponent,
    MaterialUsageTable1Component,
    MaterialUsageChart1Component,
    MaterialUsageChart2Component,
    MaterialUsageCampaignComponent,
    ProgressionSpeedComponent,
    ProgressionSpeedTable1Component,
    ThroughputComponent, UsageOptimizationComponent, OperationsSynthesisComponent,
    OperationsProgressComponent,
    OperationsProgressChart1Component,
    FuelConsumptionComponent,
    FuelConsumptionTable1Component,
  ],
  imports: [
    CommonModule,
    DxScrollViewModule,
    DxDataGridModule,
    DxLoadPanelModule,
    DomainsSelectorModule,
    DxPopupModule,
    DxPieChartModule,
    DxAccordionModule,
    DxChartModule,
    DxCircularGaugeModule,
    DxPivotGridModule
  ],
  exports: [FieldsInterventionsGeneralIIReportComponent]
})
export class FieldsInterventionsGeneralIIReportModule {
}
